// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import colors from '../../styled-components/palette';

const COLORS = {
  blue: {
    icon: colors.blueinfo350,
    color: colors.blueinfo200,
    background: colors.blueinfo900,
  },
  yellow: {
    icon: 'inerhit',
    color: colors.yellowwinamax200,
    background: colors.yellowwinamax900,
  },
  default: {
    icon: colors.bluegrey350,
    color: colors.white,
    background: colors.bluegrey800,
  },
};

const SIZES = {
  small: {
    padding: '.125em .3em',
    fontSize: '0.7em',
    fontWeight: 'normal',
    radius: '.25em',
    iconSpacing: '.125em',
    icon: '0.75em',
  },
  medium: {
    padding: '.25em .3em',
    fontSize: '1em',
    fontWeight: 'bold',
    radius: '.375em',
    iconSpacing: '.3em',
    icon: '1em',
  },
  large: {
    padding: '.3em .625em',
    fontSize: '1em',
    fontWeight: 'normal',
    radius: '.625em',
    iconSpacing: '.625em',
    icon: '1.25em',
  },
};

const MatchChipWrapper = styled.div`
  border-radius: ${({ $size }) => SIZES[$size].radius};
  padding: ${({ $size }) => SIZES[$size].padding};
  display: inline-block;
  white-space: nowrap;
  line-height: 1;

  ${({ $color }) => css`
    background: ${COLORS[$color].background};
  `};
`;

const MatchChipContent = styled.div`
  align-items: center;
  display: flex;
`;

const MatchChipIcon = styled.div`
  height: ${({ $size }) => SIZES[$size].icon};
  margin-right: ${({ $size }) => SIZES[$size].iconSpacing};
  width: ${({ $size }) => SIZES[$size].icon};

  ${({ $color }) => css`
    color: ${COLORS[$color].icon};
  `};
`;

export const MatchChipLabelClassName = 'match-chip-label';
const MatchChipLabel = styled.div`
  font-size: ${({ $size }) => SIZES[$size].fontSize};
  font-weight: ${({ $size }) => SIZES[$size].fontWeight};

  ${({ $color }) => css`
    color: ${COLORS[$color].color};
  `};
`;

type MatchChipProps = {
  className?: string;
  icon?: unknown;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  color?: 'default' | 'blue' | 'yellow';
};

const MatchChip = ({ className = '', icon, children, size = 'medium', color = 'default' }: MatchChipProps) => {
  return (
    <MatchChipWrapper className={className} $size={size} $color={color}>
      <MatchChipContent>
        {icon ? (
          <MatchChipIcon $size={size} $color={color}>
            {icon}
          </MatchChipIcon>
        ) : null}
        <MatchChipLabel className={MatchChipLabelClassName} $color={color} $size={size}>
          {children}
        </MatchChipLabel>
      </MatchChipContent>
    </MatchChipWrapper>
  );
};

export default MatchChip;
